import React, { useEffect, useState } from 'react';
import { getSaleData } from '@lib/api';
import dayjs from '@lib/dayjs';
import useHandleAPICall from '@lib/hooks/useHandleAPICall';
import useHandleError from '@lib/hooks/useHandleError';
import { media } from '@styles/mediaQuery';
import { firstArray } from '@util/array';
import Format from '@util/formatter';
import styled from 'styled-components';

import PackageJson from '../../../package.json';

const FooterContainer = styled.div<{ isMobile?: boolean }>`
  width: calc(100% - 14rem);
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1.5rem;

  background: white;

  color: ${({ theme }) => theme.neutralGray[400]};
  font-size: 0.75rem;
  line-height: 150%;

  padding: 2.5rem;
  margin-left: 14rem;
  ${media.desktop`
    width: 100%;
    padding: 1.25rem;
    margin: 0;
  `}

  .top {
    font-weight: 700;
  }

  .middle {
    line-height: 150%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem 0.5rem;

    /* :last-child {
      border-right: none;
    } */
  }

  .bottom {
    font-weight: 700;
  }
`;

const FooterContent = styled.div`
  display: flex;
  line-height: 100%;
  white-space: nowrap;

  ${media.mobile`
    white-space: normal;
    word-break: keep-all;
  `}
`;

const Divider = styled.div`
  height: 0.75rem;
  width: 1px;
  background: ${({ theme }) => theme.neutralGray[400]};
`;

const FooterItem = ({
  name,
  value,
  withoutDivider,
}: {
  name: string;
  value: string;
  withoutDivider?: boolean;
}) => {
  return (
    <>
      {value && (
        <>
          <FooterContent>
            {name} : {value}
          </FooterContent>
          {!withoutDivider && <Divider />}
        </>
      )}
    </>
  );
};

const FooterV2 = (props: any) => {
  const { createRequest } = useHandleAPICall();
  const { catchError } = useHandleError();

  const emptyMerchantData = {
    user_name: '',
    store_address: '',
    contact: '',
    br_number: '',
    mail_order_sales_number: '',
  };
  const [merchantData, setMerchantData] = useState(emptyMerchantData);
  const { user_name, store_address, contact, br_number, mail_order_sales_number } = merchantData;
  const level = localStorage.getItem('level');
  const getMerchantInfo = async () => {
    try {
      if (level !== 'user') return;
      const res = await createRequest(getSaleData, props.data.id);
      setMerchantData(firstArray<typeof emptyMerchantData>(res?.data)[0] || emptyMerchantData);
    } catch (error) {
      catchError(error);
    }
  };

  useEffect(() => {
    if (props?.data?.id) getMerchantInfo();
  }, [props?.data?.id]);
  return (
    <>
      {merchantData && (
        <FooterContainer isMobile={props?.isMobile}>
          <div className="top">상호명: 샘랩 주식회사</div>
          <div className="middle">
            <FooterItem name="대표이사" value={level === 'user' ? user_name : '심세용'} />
            <FooterItem
              name="사업자 등록번호"
              value={br_number ? Format.formatRegistrationNumber(br_number) : ''}
            />
            <FooterItem
              name="통신판매업 신고번호"
              value={level === 'user' ? mail_order_sales_number : '2026-경기시흥-0663'}
            />
            <FooterItem
              name="주소"
              value={
                level === 'user'
                  ? store_address
                  : '경기도 시흥시 은계중앙로 362 수림프라자 902호 ,1001호'
              }
            />
            <FooterItem
              name="문의"
              value={Format.formatPhone(level === 'user' ? contact : '01066594264')}
            />
            <FooterItem name="버전" value={`v${PackageJson.version}`} withoutDivider />
          </div>
          <div className="bottom">
            ©️ 2022-{dayjs().format('YYYY')} SAMLAB Corp. All rights reserved.
          </div>
        </FooterContainer>
      )}
    </>
  );
};

export default FooterV2;
